// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import TaskLogFile from '@Organisms/TaskLog/TaskLogFile/TaskLogFile';
import RouteBuilder from '@Services/RouteBuilder';
import { CardContentProps } from '../CardContentType';
import StreamCard from '@Organisms/LiveStreamData/StreamCard/StreamCard';
import { PropRender } from '@Organisms/LiveStreamData/PropRenderer/PropRenderer';
import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/locale';

export const TaskLogContent = ({ data: taskLog, base }: CardContentProps): ReactElement | null => {
    const local = useLocalMessage();

    const { message, attachment, case_task: taskData, case: caseLog } = taskLog || {};
    const { _id: taskId = '', title: taskTitle = '', case: caseData } = taskData || {};

    const { details, context, action } = base;

    const detailsCreated = {
        message,
    };

    const parent = caseLog || caseData || context;

    const libTitle = {
        create: local('stream.card.task-log.create'),
        update: local('stream.card.task-log.update'),
        delete: local('stream.card.task-log.delete'),
    };

    const displayTitle = action === 'delete' ? libTitle.delete : `${taskTitle}`;

    return (
        <StreamCard
            icon={<ICONS.TaskLogIcon />}
            title={displayTitle}
            path={parent ? RouteBuilder.compute('cases.task', { caseId: parent?._id, taskId }) : null}
            base={base}
            parent={parent}
            information="log"
        >
            {Object.entries(detailsCreated).map(([key, value]) => (
                <PropRender key={taskId + key} prop={key} value={value} type="taskLog" />
            ))}
            {details['attachment'] && attachment && <TaskLogFile attachment={attachment} taskLogId={taskId} />}
        </StreamCard>
    );
};
